import profileService from "@/services/merchant";
import { useQuery } from "@tanstack/react-query";

function useGetMerchantTypes() {
  const { data, isLoading } = useQuery(
    ["getMerchantTypes"],
    profileService.getMerchantTypes
  );
  return { data, isLoading };
}

export default useGetMerchantTypes;
